import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Fox silhouette uses the ★1 tier art. The active rendering for
// Tinder Fox goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images. The legacy
// /glyph-assets/fox.png from the single-figure pipeline is unused.
export const Fox = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/fox-1.png" size={size} alt="fox" />
)
